export const skillsData = [
    {
      label: "WEB DEV",
      data: [
        {
          skillName: "HTM",
          percentage: "90",
        },
        {
          skillName: "CSS",
          percentage: "80",
        },
        {
          skillName: "JAVASCRIPT",
          percentage: "85",
        },
        {
          skillName: "BOOTSTRAP",
          percentage: "70",
        },
        {
          skillName: "NODE JS",
          percentage: "75",
        },
        
      ],
    },
    {
      label: "LANGUAGES",
      data: [
        {
          skillName: "C",
          percentage: "70",
        },
        {
          skillName: "C++",
          percentage: "75",
        },
        {
          skillName: "Python",
          percentage: "65",
        },
        
      ],
    },
    // {
    //   label: "DATABASES",
    //   data: [
    //     {
    //       skillName: "SQL",
    //       percentage: "60",
    //     },
    //     {
    //       skillName: "MONGO DB",
    //       percentage: "65",
    //     },
       
    //   ],
    // },

    {
      label: "Soft skills",
      data: [
        {
          skillName: "Analytical Skills",
          percentage: "90",
        },
        {
          skillName: "Effective communication",
          percentage: "95",
        },
        {
          skillName: "Conflict resolution and negotiation",
          percentage: "90",
        },
        {
          skillName: "Creativity",
          percentage: "90",
        },
       
      ],
    },
   
    
  ];